import React from 'react';

import ItemLink from 'components/Layouts/Admin/Dashboard/Navigation/ItemLink';
import { TripEventWebViewType } from 'hooks/useWebViewLinksHandler/constants';
import { IActionButton } from 'utils/itineraryDetails/types';
import { checkIsWebview } from 'utils/mobileApplication';

import s from './index.module.css';

const ActionButton = (props: IActionButton) => {
  const { buttonColor: backgroundColor, textColor: color, hyperlink = '', text, active } = props;
  const style = { backgroundColor, color };

  if (!active || !hyperlink) return null;
  const isWebview = checkIsWebview();

  const handleOnClick = (e: MouseEvent) => {
    if (!isWebview) return;
    e.preventDefault();
    // @ts-ignore
    window?.ReactNativeWebView?.postMessage?.(JSON.stringify({ type: TripEventWebViewType.openLink, url: hyperlink }));
  };

  return (
    <ItemLink
      noUnderline
      isRealLink
      href={hyperlink}
      style={style}
      className={s.actionButton}
      linkClassName={s.link}
      onClick={handleOnClick}
    >
      {text}
    </ItemLink>
  );
};

export { ActionButton };
